module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



// WEBPACK FOOTER //
// webpack://pdfjs-dist/build/pdf/node_modules/core-js/modules/_fails.js